import React, { useState } from "react";
import { Plane, Instagram, Facebook, MapPin, Phone, Mail, ArrowRight, Star } from "lucide-react";
import { Link } from "react-router-dom";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    setStatus("");
    try {
      await axios.post(`${API}/newsletter`, { email });
      setStatus("Subscribed! Look out for our curated journeys.");
      setEmail("");
    } catch (err) {
      setStatus("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-[#0A2342] text-white rounded-t-[2.5rem] md:rounded-t-[3rem] mt-12 pt-20 pb-10 px-6 lg:px-10 relative overflow-hidden" data-testid="footer">
      <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full border border-[#C9A227]/15" />
      <div className="max-w-7xl mx-auto relative">
        {/* Top: Newsletter + brand */}
        <div className="grid lg:grid-cols-2 gap-12 mb-16 pb-16 border-b border-white/10">
          <div>
            <div className="flex items-center">
  <img
    src="/Travwave-logo-white.png"
    alt="Travwave Luxury Travel"
    className="h-24 w-auto object-contain"
  />
            </div>
            <p className="mt-6 text-white/70 max-w-md leading-relaxed">
              A travel atelier crafting bespoke international holidays, luxury escapes and visa services since 2014. Trusted by 10,000+ travellers.
            </p>
            <div className="mt-6 flex items-center gap-2 text-white/80">
              <Star className="w-4 h-4 fill-[#C9A227] text-[#C9A227]" />
              <Star className="w-4 h-4 fill-[#C9A227] text-[#C9A227]" />
              <Star className="w-4 h-4 fill-[#C9A227] text-[#C9A227]" />
              <Star className="w-4 h-4 fill-[#C9A227] text-[#C9A227]" />
              <Star className="w-4 h-4 fill-[#C9A227] text-[#C9A227]" />
              <span className="text-sm ml-2">5 / 5 · 100+ Google reviews</span>
            </div>
          </div>

          <div>
            <div className="overline text-[#C9A227]">Newsletter</div>
            <h3 className="font-display text-2xl md:text-3xl mt-3 leading-tight">
              Quiet, curated travel inspiration. <br />Twice a month.
            </h3>
            <form onSubmit={subscribe} className="mt-6 flex flex-col sm:flex-row gap-3" data-testid="newsletter-form">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                data-testid="newsletter-email"
                className="flex-1 bg-white/5 border border-white/15 rounded-full px-5 py-3 placeholder-white/40 outline-none focus:border-[#C9A227]"
              />
              <button type="submit" disabled={loading} data-testid="newsletter-submit" className="btn-gold whitespace-nowrap">
                {loading ? "Subscribing…" : "Subscribe"} <ArrowRight className="w-4 h-4" />
              </button>
            </form>
            {status && <div className="mt-3 text-sm text-[#C9A227]" data-testid="newsletter-status">{status}</div>}
          </div>
        </div>

        {/* Link columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-12">
          <div>
            <div className="overline text-[#C9A227] mb-4">Quick Links</div>
            <ul className="space-y-3 text-white/75 text-sm">
              <li><Link to="/" className="hover:text-[#C9A227]">Home</Link></li>
              <li><Link to="/destinations" className="hover:text-[#C9A227]">Destinations</Link></li>
              <li><Link to="/luxury" className="hover:text-[#C9A227]">Luxury Holidays</Link></li>
              <li><Link to="/about" className="hover:text-[#C9A227]">About</Link></li>
              <li><Link to="/blogs" className="hover:text-[#C9A227]">Journal</Link></li>
              <li><Link to="/contact" className="hover:text-[#C9A227]">Contact</Link></li>
            </ul>
          </div>
          <div>
            <div className="overline text-[#C9A227] mb-4">Destinations</div>
            <ul className="space-y-3 text-white/75 text-sm">
              <li><Link to="/destinations" className="hover:text-[#C9A227]">Maldives</Link></li>
              <li><Link to="/destinations" className="hover:text-[#C9A227]">Bali</Link></li>
              <li><Link to="/destinations" className="hover:text-[#C9A227]">Dubai</Link></li>
              <li><Link to="/destinations" className="hover:text-[#C9A227]">Japan</Link></li>
              <li><Link to="/destinations" className="hover:text-[#C9A227]">Europe</Link></li>
            </ul>
          </div>
          <div>
            <div className="overline text-[#C9A227] mb-4">Visa Services</div>
            <ul className="space-y-3 text-white/75 text-sm">
              <li><Link to="/visa" className="hover:text-[#C9A227]">USA · Canada · UK</Link></li>
              <li><Link to="/visa" className="hover:text-[#C9A227]">Schengen · Australia</Link></li>
              <li><Link to="/visa" className="hover:text-[#C9A227]">Singapore · Japan</Link></li>
              <li><Link to="/visa" className="hover:text-[#C9A227]">Thailand · Dubai</Link></li>
            </ul>
          </div>
          <div>
            <div className="overline text-[#C9A227] mb-4">Office</div>
            <ul className="space-y-3 text-white/75 text-sm">
              <li className="flex gap-2 items-start"><MapPin className="w-4 h-4 mt-0.5 text-[#C9A227]" />Delhi · Patna· Ghaziabad · Jaipur · Goa</li>
              <li className="flex gap-2 items-start"><Phone className="w-4 h-4 mt-0.5 text-[#C9A227]" />+91 96224 69097</li>
              <li className="flex gap-2 items-start"><Mail className="w-4 h-4 mt-0.5 text-[#C9A227]" />info@travwave.in</li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row gap-4 items-center justify-between">
          <div className="text-white/55 text-xs">© {new Date().getFullYear()} Travwave. All rights reserved.</div>
          <div className="flex items-center gap-3">
            {[
  { icon: Instagram, url: "https://www.instagram.com/trav.wave/", label: "Instagram" },
  { icon: Facebook, url: "https://www.facebook.com/travwavet", label: "Facebook" },
].map(({ icon: I, url, label }) => (
  <a
    key={label}
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={label}
    className="w-10 h-10 rounded-full border border-white/15 hover:border-[#C9A227] hover:bg-[#C9A227]/10 flex items-center justify-center transition-colors"
  >
    <I className="w-4 h-4 text-white/80" />
  </a>
))}
          </div>
        </div>
      </div>
    </footer>
  );
}
